module.exports = __webpack_public_path__ + "img/icon_sm_cght.32afa8a8.png";